<template>
  <HeaderComponent />
  <NavigationComponent :alwaysShowLogo="true" />
  <ContactComponent />
  <FooterComponent />
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import NavigationComponent from '@/components/NavigationComponent.vue';
import ContactComponent from '@/components/ContactComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  name: 'ContactPage',
  components: {
    HeaderComponent,
    NavigationComponent,
    ContactComponent,
    FooterComponent
  }
};
</script>
